import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // useEffect(() => {
  //   setTimeout(() => {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //     // window.scrollTo(0, 0);
  //   }, 1000);

  //   // const scrollToTopTest = () => {
  //   //   // Laat eerst React volledig renderen
  //   //   setTimeout(() => {
  //   //     requestAnimationFrame(() => {
  //   //       // Pas scroll toe ALS we niet al bovenaan zijn
  //   //       if (window.scrollY > 50) {
  //   //         window.scrollTo({ top: 0, behavior: 'auto' });
  //   //       }
  //   //     });
  //   //   }, 0);
  //   // };

  //   // scrollToTopTest();
  // }, [pathname]);

  return null;
};

export default ScrollToTop;
